import { render, staticRenderFns } from "./ODpay_order_detail.vue?vue&type=template&id=c8dbf42a&scoped=true"
import script from "./ODpay_order_detail.vue?vue&type=script&lang=js"
export * from "./ODpay_order_detail.vue?vue&type=script&lang=js"
import style0 from "./ODpay_order_detail.vue?vue&type=style&index=0&id=c8dbf42a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8dbf42a",
  null
  
)

export default component.exports